export { CrmContactProfilePageComponent } from './contact-profile.component';
export { CrmContactModule } from './contact.module';
